import React, {  useState, useEffect } from 'react';
import {Alert, Button, Card, Form, Modal, Table} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner, faWrench, faUserShield } from '@fortawesome/free-solid-svg-icons'
import {useAuth} from "../authprovider";
import {
    Link
} from "react-router-dom";
import { useTranslation } from 'react-i18next';

function AddBuildingModal(props){
    const {buildings} = useAuth();
    const { t } = useTranslation();
    const [validated, setValidated] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [alert, setAlert] = useState({
        show:false,
        content: "",
    })

    let handleSubmit = (event)=>{

        event.preventDefault();
        event.stopPropagation();

        if(disabled)
            return;

        const form = event.currentTarget;
        if (form.checkValidity() === true) {
            setDisabled(true);
            let elements = form.elements
            let data = {
                name:elements.name.value,
                code:elements.code.value,
                address:elements.address.value,
                users:elements.users.value,
            }


            buildings.add(data, response=>{
                const {success, error, content} = response;
                if(success === true){
                    props.onHide(content);
                } else {
                    setAlert({show:true, content: error})
                }
                setDisabled(false);
            })
        }

        setValidated(true);
    }

    let hideAlert = ()=>{ setAlert({show:false, content: ""})}

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {t('buildings.newBuilding')}
                </Modal.Title>
            </Modal.Header>
            <Form disabled noValidate validated={validated} action={"post"} onSubmit={handleSubmit} >
                <Modal.Body>
                    <Alert show={alert.show} variant={"warning"} onClose={hideAlert} dismissible>
                        <p>
                            {alert.content}
                        </p>
                    </Alert>
                    <Form.Group className="mb-3" controlId="objectName">
                        <Form.Label>{t('buildings.nameLabel')}</Form.Label>
                        <Form.Control required type="text" name={"name"} placeholder={t('buildings.namePlaceholder')} />
                        <Form.Text className="text-muted" >
                            {t('buildings.nameHelp')}
                        </Form.Text>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="objectCode">
                        <Form.Label>{t('buildings.codeLabel')}</Form.Label>
                        <Form.Control required type="text" name={"code"} placeholder={t('buildings.codePlaceholder')} />
                        <Form.Text className="text-muted" >
                            {t('buildings.codeHelp')}
                        </Form.Text>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="objectAddress">
                        <Form.Label>{t('buildings.addressLabel')}</Form.Label>
                        <Form.Control type="text" name={"address"} placeholder={t('buildings.addressPlaceholder')} />
                        <Form.Text className="text-muted" >
                            {t('buildings.addressHelp')}
                        </Form.Text>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="objectStartUsersLp">
                        <Form.Label>{t('buildings.usersCountLabel')}</Form.Label>
                        <Form.Control type="number" name={"users"} placeholder={t('buildings.usersCountPlaceholder')} />
                        <Form.Text className="text-muted" >
                            {t('buildings.usersCountHelp')}
                        </Form.Text>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button disabled={disabled} type={"submit"} name={"Zapisz"}>
                        {disabled ? <FontAwesomeIcon icon={faSpinner}  spin/> : t('buildings.save') }
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default function BuildingsManager() {
    const auth = useAuth();
    const { t } = useTranslation();
    const [loadBuildings, setLoadBuildings] = useState(true)
    const [buildings, setBuildings] = useState([])
    const [showModalAddEdit, setShowModalAddEdit] = useState(false)


    useEffect(()=>{
        if(loadBuildings){
            auth.buildings.get((response)=>{
                const {success,error,content} = response;
                if(success === true){
                    setLoadBuildings(false)
                    setBuildings(content)
                } else {
                    alert(error);
                }
            });
        }
    })

    const addBuilding = (building)=>{
        setBuildings([...buildings, building])
    }

    const handleHideCreateModal = (result)=>{
        if(result)
            addBuilding(result)
        setShowModalAddEdit(false)
    }


    const handleAddClick = ()=>{
        setShowModalAddEdit(true)
    }

    let lp = 1;

    return (

        <div className={"container"}>
            <Card className={"m-2 p-2"} key={"data"}>
                <div >
                    <Button name={"Dodaj"} className="me-4" style={{position:"fixed", bottom:"10px", right:"10px"}} variant="warning " onClick={handleAddClick} >
                        {t('buildings.add')}
                    </Button>
                    <Table striped bordered hover>
                        <thead>
                        <tr>
                            <th>{t('buildings.tableHeaderLp')}</th>
                            <th>{t('buildings.tableHeaderName')}</th>
                            <th>{t('buildings.tableHeaderCode')}</th>
                            <th>{t('buildings.tableHeaderAddress')}</th>
                            <th>{t('buildings.tableHeaderUsers')}</th>
                            <th>{t('buildings.tableHeaderEdit')}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            buildings && buildings.map(building=>{
                                return (
                                        <tr key={building.id}>
                                            <td>{lp++}</td>
                                            <td>{building.name}</td>
                                            <td>{building.code}</td>
                                            <td>{building.address}</td>
                                            <td>{building.users}</td>
                                            <td>
                                                <Link className={"btn btn-outline-info me-2"} to={{
                                                    pathname: "/controll",
                                                    hash: building.id,
                                                    state: { fromDashboard: true }
                                                }}><FontAwesomeIcon icon={faUserShield} /></Link>
                                                <Link className={"btn btn-danger"} to={"/building#"+building.id}><FontAwesomeIcon icon={faWrench} /></Link>
                                            </td>
                                        </tr>
                                )
                            })
                        }
                        </tbody>
                    </Table>
                </div>
                <AddBuildingModal show={showModalAddEdit } onHide={handleHideCreateModal}/>
            </Card>
        </div>
    )

}
